<template>
  <div class="myCard">
    <van-cell-group class="box">
      <van-cell
        class="item"
        center
        clickable
        title="头像"
        @click="head_show = true"
      >
        <template #right-icon>
          <img class="head" :src="userInfo.avatar" />
        </template>
      </van-cell>
      <van-cell
        class="item"
        center
        clickable
        title="姓名"
        :value="userInfo.nickname"
        @click="changeName"
      />
    </van-cell-group>
    <van-cell-group class="box">
      <van-cell
        class="item"
        center
        clickable
        value-class="company"
        title="品牌 （公司简称）"
        :value="brandList.length != 0 ? brandList[0].title : '请添加'"
        @click="changeBrand"
      />
    </van-cell-group>
    <div class="tip"><span>一定要设置品牌（公司简称），获取相关推荐</span></div>
    <van-cell-group class="box">
      <van-cell
        class="item"
        center
        clickable
        title="手机"
        :value="
          userInfo.phone == null || userInfo.phone == ''
            ? '请输入手机号'
            : userInfo.phone
        "
        @click="changeTel"
      />
      <van-cell
        class="inputfile item"
        center
        clickable
        title="上传微信二维码"
        value="点击上传微信二维码"
        @click="imgClick()"
      />
      <input
        style="float: left; display: none"
        type="file"
        id="uploadFile"
        accept="image/*"
        @change="readLocalFile()"
      />
    </van-cell-group>
    <div class="tip">
      <span @click="getWechatCode">如何获取我的微信二维码？</span>
    </div>
    <van-cell-group class="box">
      <van-cell
        label-class="labelitem"
        center
        clickable
        title="签名"
        :label="userInfo.personality == '' ? '暂无签名' : userInfo.personality"
        @click="changeSign"
      />
    </van-cell-group>
    <!-- <van-cell-group class="box">
      <van-cell center clickable title="文章顶部显示我的名片和签名">
        <template #right-icon>
          <van-switch
            v-model="showCard"
            size=".44rem"
            active-color="#ff410a"
            inactive-color="#f5f5f5"
          />
        </template>
      </van-cell>
    </van-cell-group> -->
    <!-- <van-cell-group class="box">
      <van-cell center clickable title="文章底部名片显示热卖产品">
        <van-switch
          v-model="showGoods"
          size=".44rem"
          active-color="#ff410a"
          inactive-color="#f5f5f5"
        />
      </van-cell>
    </van-cell-group> -->
    <!-- <van-cell-group class="box">
      <van-cell center clickable title="去掉「变成我的...」广告按钮">
        <van-switch
          v-model="showAdvertising"
          size=".44rem"
          active-color="#ff410a"
          inactive-color="#f5f5f5"
        />
      </van-cell>
    </van-cell-group> -->
    <!-- <div class="advertising">
      <span>广告按钮 可以帮你推广赚钱</span>
      <span class="view_detail">查看详情</span>
    </div> -->
    <van-action-sheet
      v-model="head_show"
      :actions="head_actions"
      cancel-text="取消"
      close-on-click-action
      @select="onHeaderSelect"
    />
  </div>
</template>

<script>
import { Cell, CellGroup, Switch, ActionSheet, Dialog, Toast } from "vant";
import { getUser } from "@api/user";
import {
  getFollowLstNew,
  getBrandSaveNew,
  getUploadImageNew,
  postUserContact
} from "@/api/public";
export default {
  name: "MyCard",
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Switch.name]: Switch,
    [ActionSheet.name]: ActionSheet,
    [Dialog.name]: Dialog
  },
  data() {
    return {
      userInfo: "",
      brandList: "", // 品牌列表
      showCard: true, // 文章顶部显示我的名片和签名
      showGoods: true, // 文章顶部显示热卖产品
      showAdvertising: true, // 去掉广告按钮
      sign: "", // 签名内容
      wechat_show: false // 上传微信二维码弹窗
    };
  },
  mounted() {
    // getBrandSaveNew({
    //   title: "九月的iphone15",
    // }).then((res) => {
    //   console.log(res);
    // });
    this.getFollowLstNew();
    this.User();
  },
  methods: {
    /**
     * 上传图片
     */
    imgClick() {
      document.getElementById("uploadFile").click();
    },
    /**
     * 点击选中图片
     */
    readLocalFile() {
      var param = new FormData();
      let files = event.target.files[0];
      param.append("file", files, files.name); //  append 中的 字符串名称 根据后端接口提示修改
      getUploadImageNew(param)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            console.log(res);
            let url = res.data.url;
            postUserContact({ wx_qr_code: url })
              .then(res => {
                if (res.status == 200) {
                  Toast({ message: res.msg });
                }
              })
              .catch(err => {
                Toast({ message: err.msg });
              });
          } else {
            Toast({ message: res.msg });
          }
        })
        .catch(err => {
          Toast({ message: err.msg });
        });
    },
    /**
     * 获取个人信息
     */
    User() {
      const that = this;
      getUser().then(res => {
        that.userInfo = res.data;
      });
    },
    /**
     * 我的关注 行业/品牌
     */
    getFollowLstNew() {
      getFollowLstNew().then(res => {
        this.brandList = res.data.brand;
        console.log(this.brandList);
      });
    },
    /**
     * 修改头像
     */
    onHeaderSelect(item) {
      console.log(item);
    },
    /**
     * 上传微信二维码
     */
    onWechatSelect(item) {
      console.log(item);
    },
    /**
     * 跳转修改品牌
     */
    changeBrand() {
      this.$router.push({ path: "/jiaodian/brand/" });
    },
    /**
     * 跳转修改姓名页
     */
    changeName() {
      // this.$router.push({ path: "/my/card/changeName" });
    },
    /**
     * 跳转修改手机号页
     */
    changeTel() {
      this.$router.push({
        path: "/my/card/changeTel",
        query: {
          tel: this.userInfo.phone
        }
      });
    },
    /**
     * 跳转修改签名页
     */
    changeSign() {
      this.$router.push({
        path: "/my/card/changeSign",
        query: {
          sign: this.userInfo.personality
        }
      });
    },
    /**
     * 获取二维码图片提示
     */
    getWechatCode() {
      Dialog.alert({
        message:
          "打开 微信：我 > 个人信息 > 我的二维码，点击右上角保存，然后就可以上传了",
        confirmButtonText: "知道了",
        confirmButtonColor: "#ff410a",
        closeOnClickOverlay: true
      }).then(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.myCard {
  .head {
    width: 0.8rem;
    height: 0.8rem;
    border-radius: 50%;
  }
  .item {
    height: 1rem;
  }
  .company {
    color: #ff410a;
  }
  .box {
    margin-top: 0.2rem;
  }
  .tip {
    font-size: 0.24rem;
    color: #999999;
    line-height: 0.5rem;
    text-align: right;
    padding-right: 0.15rem;
  }
  .van-cell__title {
    font-size: 0.3rem;
  }
  .van-cell__value {
    font-size: 0.28rem;
  }
  .advertising {
    font-size: 0.28rem;
    color: #999999;
    text-align: center;
    line-height: 0.8rem;
    .view_detail {
      color: #ff410a;
      margin-left: 0.16rem;
    }
  }
  .labelitem {
    font-size: 0.28rem;
    padding: 0.1rem 0;
  }
}
</style>
